import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  personInfo: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.FETCH_PERSON_INFO_PENDING: {
      return {
        ...state,
        personInfo: []
      };
    }

    case actionsTypes.FETCH_PERSON_INFO_FULFILLED: {
      return {
        ...state,
        personInfo: action.payload
      };
    }

    default:
      return state;
  }
};

export default reducer;
